export class WideModal {
    constructor(
        public width: number,
        public useWideLayout: boolean
    ) {}
}